import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";

// Configure the Redux store
export const store = configureStore({
  reducer: {
    auth: authReducer,
    // Add other reducers here as needed
    // example: user: userReducer,
    // example: settings: settingsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [],
        // Ignore these field paths in all actions
        ignoredActionPaths: [],
        // Ignore these paths in the state
        ignoredPaths: [],
      },
    }),
});

// Export types for TypeScript (if needed in future)
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;



